import { EventedObject } from "../base/evented-object";
/**
 * 图层基类
 */
export class Layer extends EventedObject {
    /**
     * 图层是否可见
     */
    get visible() {
        return this._visible;
    }
    /**
     * 图层可见设置
     */
    set visible(value) {
        this._visible = value;
    }
    /**
     * 图层可见缩放级别设置
     */
    get minZoom() {
        return this._zooms[0];
    }
    get maxZoom() {
        return this._zooms[1];
    }
    set minZoom(value) {
        this._zooms[0] = value;
    }
    set maxZoom(value) {
        this._zooms[1] = value;
    }
    set zoom(value) {
        this._zooms = value;
    }
    /**
     * 图层是否可交互
     */
    get interactive() {
        return this._interactive;
    }
    /**
     * 图层可交互设置
     */
    set interactive(value) {
        this._interactive = value;
    }
    /**
     * 图层顺序
     */
    get index() {
        return this._index;
    }
    /**
     * 图层顺序设置
     */
    set index(value) {
        this._index = value;
    }
    /**
     * 创建图层
     */
    constructor() {
        super();
        /**
         * 图层可见设置
         */
        this._visible = true;
        /**
         * 图层可见缩放级别
         */
        this._zooms = [1, 20];
        /**
         * 图层可交互设置
         */
        this._interactive = true;
        /**
         * 图层顺序（z-index）
         * @remarks
         * TODO: marker的异步加载，会影响绘制顺序
         */
        this._index = 0; //z-index
    }
}
